var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93994 5.80077C6.93968 6.33121 6.72871 6.83981 6.35345 7.2147C5.97819 7.58958 5.46937 7.80004 4.93894 7.79977C4.40851 7.79951 3.89991 7.58854 3.52502 7.21328C3.15014 6.83802 2.93968 6.32921 2.93994 5.79877C2.94021 5.26834 3.15117 4.75974 3.52644 4.38485C3.9017 4.00997 4.41051 3.79951 4.94094 3.79977C5.47137 3.80004 5.97998 4.01101 6.35486 4.38627C6.72975 4.76153 6.94021 5.27034 6.93994 5.80077ZM6.99994 9.28077H2.99994V21.8008H6.99994V9.28077ZM13.3199 9.28077H9.33994V21.8008H13.2799V15.2308C13.2799 11.5708 18.0499 11.2308 18.0499 15.2308V21.8008H21.9999V13.8708C21.9999 7.70077 14.9399 7.93077 13.2799 10.9608L13.3199 9.28077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.74076807b0281b00cea44a80ce753ed2.svg";
export { ForwardRef as ReactComponent };